module.exports = __webpack_public_path__ + "curalate-font-v6.712ff63a259fdbbdeb291adcb13b9557.svg";